/**
 * Firebase Functions client wrapper
 * Provides callable function helpers
 */
import { httpsCallable } from 'firebase/functions'
import { getFirebaseFunctions } from './firebase.js'

/**
 * Create a callable function reference
 * @param {string} name - Function name as exported from functions/index.js
 * @param {Object} options - Options for the callable
 * @param {number} [options.timeout] - Timeout in milliseconds (default: 70000)
 * @returns {Function} Callable function
 */
export function createCallable(name, options = {}) {
  const functions = getFirebaseFunctions()
  return httpsCallable(functions, name, options)
}

/**
 * Call a Firebase Function
 * @param {string} name - Function name
 * @param {Object} data - Request data
 * @param {Object} options - Options for the callable
 * @param {number} [options.timeout] - Timeout in milliseconds (default: 70000)
 * @returns {Promise<Object>} Response data
 */
export async function callFunction(name, data = {}, options = {}) {
  const callable = createCallable(name, options)
  const result = await callable(data)
  return result.data
}
